import { PredefinedOptionType } from '../../enum';
import { EventType, ItemType } from '../../lib';
import { isArticleOption, isSectionOption } from '../../lib/option';
import {
  ArticleInteractionExternEvent,
  ArticleListItemNavigationEvent,
  ArticleListNavigationEvent,
  BaseExternalEvent,
  PreSupportSelectionEvent,
  ResolutionEvent,
  SystemOptionEvent
} from '../../types';

export function isSectionOptionEvent(event: any): event is SystemOptionEvent {
  return EventType.isOptionEvent(event) && isSectionOption(event.payload.selected);
}

export function isArticleOptionEvent(event: any): event is SystemOptionEvent {
  return EventType.isOptionEvent(event) && isArticleOption(event.payload.selected);
}

export function isArticleFromListNavigationEvent(event: any): event is ArticleListItemNavigationEvent {
  return EventType.isArticleListNavigationEvent(event) && isArticleOption(event.payload.selected);
}

export function isOverlongResolutionEvent(event: any): event is ResolutionEvent {
  return EventType.isResolutionEvent(event) && ItemType.isOverlongAiConversationResolutionMessage(event.message);
}

export function isStaleConversationResolutionEvent(event: any): event is ResolutionEvent {
  return EventType.isResolutionEvent(event) && ItemType.isStaleAiConversationResolutionMessage(event.message);
}

export function isArticleSupportRequestEvent(event: any): event is ArticleInteractionExternEvent {
  return EventType.isArticleInteractionEvent(event) && event.payload.interaction === 'support-request';
}

export function isBrowseOtherArticlesEvent(event: any): event is ArticleListNavigationEvent {
  return (
    EventType.isArticleListNavigationEvent(event) &&
    event.payload.selected === PredefinedOptionType.BROWSE_OTHER_ARTICLES
  );
}

export function isIssueNotListedArticlesEvent(event: any): event is ArticleListNavigationEvent {
  return (
    EventType.isArticleListNavigationEvent(event) && event.payload.selected === PredefinedOptionType.ISSUE_NOT_LISTED
  );
}

export function isAiEligibleExternalEvent(event: BaseExternalEvent) {
  return (
    EventType.isResumeAIChat(event) ||
    EventType.isArticleInteractionEvent(event) ||
    EventType.isUserLoginEvent(event) ||
    EventType.isGuestLoginEvent(event) ||
    EventType.isStartSelectedEntityFlowEvent(event)
  );
}

export function isConnectPreSupportSelectionEvent(event: any): event is PreSupportSelectionEvent {
  return (
    EventType.isPreSupportPromptSelectionEvent(event) &&
    (event.payload.selected === PredefinedOptionType.CONNECT_TO_SUPPORT ||
      event.payload.selected === PredefinedOptionType.NEED_MORE_HELP)
  );
}

export function isUserLoginFromAIEvent(event: any): event is ResolutionEvent {
  return EventType.isResolutionEvent(event) && ItemType.isUserLoginFromAIResolutionMessage(event.message);
}
